import { useEffect, useState } from "react";

function getMediaQueryList() {
  return matchMedia("(hover: hover)");
}
export default function useHasHover() {
  const [hasHover, setHasHover] = useState<boolean>(
    getMediaQueryList().matches,
  );

  useEffect(() => {
    const mediaQueryList = getMediaQueryList();
    setHasHover(mediaQueryList.matches);

    const changeHandler = () => setHasHover(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", changeHandler);

    return () => {
      mediaQueryList.removeEventListener("change", changeHandler);
    };
  }, []);

  return hasHover;
}
